package org.gymly.util

import org.gymly.canSwitchWebExperience
import org.gymly.model.PortalTab
import org.gymly.navigation.WebHistory
import org.gymly.navigation.currentWebPageUrl

/**
 * Dirección a la que vuelve el socio después de pagar en Stripe o PayPal.
 * <ul>
 *   <li>Web: vuelve a la misma página, en la pestaña de donde pagó (tienda o pagos).</li>
 *   <li>Android, iOS y escritorio: no hay página web propia de la app; vuelve a la API y el socio regresa a la
 *       app. Allí la app verifica el pago al abrir la pestaña.</li>
 * </ul>
 */
fun portalReturnUrl(tab: PortalTab, apiBase: String): String {
    val page = currentWebPageUrl()
    return if (canSwitchWebExperience() && page.isNotBlank()) {
        page + WebHistory.portalHash(tab)
    } else {
        apiBase.trimEnd('/') + "/api/health"
    }
}
